import {
  Component,
  EventEmitter,
  Inject,
  OnInit,
  Output,
} from '@angular/core';
import {
  FormBuilder,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import {
  MAT_DIALOG_DATA,
  MatDialogModule,
  MatDialogRef,
} from '@angular/material/dialog';

import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

import { DynamicFormQuestionComponent } from '../../../inputfileds/dynamic-form-question/dynamic-form-question.component';
import { AccordionPageService } from '../../../inputfileds/form_services/WebsiteManagement/accordian_page/accordion-page.service';
import { Inputfiledsbase } from '../../../inputfileds/models/inputfiledsbase';
import { ToastService } from '../../../Services/toast/toast.service';

export interface TextUploadResult {
  text_list: { title: string; content: string }[];
}

@Component({
  selector: 'app-dynamic-text-upload',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatDialogModule,
    MatButtonModule,
    MatProgressSpinnerModule,
    DynamicFormQuestionComponent,
  ],
  templateUrl: './dynamic-text-upload.component.html',
  styleUrls: ['./dynamic-text-upload.component.scss'],
})
export class DynamicTextUploadComponent implements OnInit {
  @Output() cancel = new EventEmitter<void>();
  @Output() formSubmit = new EventEmitter<TextUploadResult>();

  textForm: FormGroup;
  questions: Inputfiledsbase<string>[] = [];
  isSaving = false;

  constructor(
    private fb: FormBuilder,
    private accordionService: AccordionPageService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<DynamicTextUploadComponent>,
    private toast: ToastService,
  ) {
    this.textForm = this.fb.group({});
  }

  ngOnInit(): void {
    // Load questions from the service — same pattern as DynamicPageCreationComponent
    this.accordionService.getTextAccordionData().subscribe((questions) => {
      this.questions = questions;

      // Dynamically build form controls from the question definitions
      questions.forEach((q) => {
        const validators = q.required ? [Validators.required] : [];
        if (q.maxLength) {
          validators.push(Validators.maxLength(q.maxLength));
        }
        this.textForm.addControl(q.key, this.fb.control(q.value || '', validators));
      });

      // Pre-fill when editing an existing text entry
      if (this.data?.initialData) {
        this.textForm.patchValue(this.data.initialData);
      }
    });
  }

  trackByKey(_: number, q: Inputfiledsbase<string>): string {
    return q.key;
  }

  // ── Actions ───────────────────────────────────────────────────────────────

  onSubmit(): void {
    if (this.textForm.invalid) {
      this.textForm.markAllAsTouched();
      this.toast.showToast('warning', 'Please fill in all required fields');
      return;
    }

    const { title, content } = this.textForm.value;
    this.formSubmit.emit({
      text_list: [{ title: title.trim(), content: content.trim() }],
    });
    this.dialogRef.close();
  }

  onCancel(): void {
    this.cancel.emit();
    this.dialogRef.close();
  }
}
